module.exports = __webpack_public_path__ + "static/media/field.d5d6010f.jpeg";